import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MapcomponentComponent } from "./mapcomponent/mapcomponent.component";
import { AngularMaterialModule } from "../../material.module";
import { HotelreviewComponent } from "./hotelreview/hotelreview.component";
import { HotelinfoComponent } from "./hotelinfo/hotelinfo.component";
import { SvgmapinfoComponent } from "./svgmapinfo/svgmapinfo.component";
import { ParkinginfoComponent } from "./parkinginfo/parkinginfo.component";
import { DirectiveModule } from "../../directives/directive.module";
import { PartnerloginComponent } from "./partnerlogin/partnerlogin.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RecaptchaV3Module } from "ng-recaptcha";
import { TvangebotimagevideoComponent } from "./tvangebotimagevideo/tvangebotimagevideo.component";
import { TerminComponent } from "./termin/termin.component";
import { OfferpackformComponent } from "./offerpackform/offerpackform.component";
import { NewlettermodalComponent } from "./newlettermodal/newlettermodal.component";
import { CustomemailComponent } from "./customemail/customemail.component";
import { PipeModule } from "../../pipe/pipe.module";
import { ConfirmationComponent } from "./confirmation/confirmation.component";
import { FlugDetailComponent } from "./flugdetail/flugdetail.component";
import { KeywordsModule } from "../keywords/keywords.module";
import { PreisalarmmodalComponent } from "./preisalarmmodal/preisalarmmodal.component";
import { ToolsModule } from "../tools/tools.module";
import { ImagesliderComponent } from "../imageslider/imageslider.component";
import { HotelsModule } from "../hotels/hotels.module";
import { HotelDetailsComponent } from "./hoteldetails/hoteldetails.component";
import { DetailsMapComponent } from "./hoteldetails/map/map.component";
import { HotelReviewComponent } from "./hoteldetails/hotelreview/hotelreview.component";
@NgModule({
  declarations: [
    MapcomponentComponent,
    HotelreviewComponent,
    SvgmapinfoComponent,
    ParkinginfoComponent,
    TvangebotimagevideoComponent,
    TerminComponent,
    PartnerloginComponent,
    HotelinfoComponent,
    OfferpackformComponent,
    CustomemailComponent,
    FlugDetailComponent,
    NewlettermodalComponent,
    ConfirmationComponent,
    PreisalarmmodalComponent,
    HotelDetailsComponent,
    DetailsMapComponent,
    HotelReviewComponent,
  ],
  imports: [
    CommonModule,
    DirectiveModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    DirectiveModule,
    RecaptchaV3Module,
    PipeModule,
    ImagesliderComponent,
    ToolsModule,
    KeywordsModule,
  ],
  exports: [MapcomponentComponent, HotelreviewComponent],
})
export class ModalsModule {}
